import GastosTemplate from "../components/templates/GastosTemplate";

const Gastos = () => {
    return <GastosTemplate/>;
};

export default Gastos;